import { makeObservable, observable, action } from 'mobx';

export interface ProofOfDeliveryImage {
  imageType: string;
  imageUrl: string;
}

export class ProofOfDeliveryDetails {
  @observable protected _proofOfDeliveryDetails: ProofOfDeliveryImage[] = [];

  constructor() {
    makeObservable(this);
  }

  @action
  setImages(details: ProofOfDeliveryImage[]): void {
    this._proofOfDeliveryDetails = details;
  }

  get getImages(): ProofOfDeliveryImage[] {
    return this._proofOfDeliveryDetails;
  }
}
